export default function Footer() {
  return (
    <footer className="bg-primary-500 text-background-50/80 border-t border-background-50/10">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2">
            <span className="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-accent-500 text-primary-950">
              <i className="ri-shield-check-line text-lg"></i>
            </span>
            <span className="font-heading text-background-50 text-lg font-semibold">
              AV<span className="text-accent-400">certifica</span>
            </span>
          </div>
          <p className="mt-4 text-sm text-background-50/60 max-w-md">
            A AVcertifica atua com emissão e renovação de certificados digitais, oferecendo suporte e orientação durante o processo.
          </p>
          <div className="mt-4 flex flex-col gap-1 text-sm text-background-50/70">
            <div className="flex items-center gap-2">
              <i className="ri-map-pin-line text-accent-400 text-xs"></i>
              Blumenau/SC
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-time-line text-accent-400 text-xs"></i>
              Mais de 4 anos no mercado de certificação digital
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-video-chat-line text-accent-400 text-xs"></i>
              Atendimento online por videoconferência
            </div>
          </div>
        </div>

        <div>
          <div className="font-heading text-background-50 font-semibold mb-3">Links rápidos</div>
          <ul className="space-y-2 text-sm">
            <li>
              <a href="#inicio" className="hover:text-accent-400 transition-colors">Início</a>
            </li>
            <li>
              <a href="#certificados" className="hover:text-accent-400 transition-colors">Certificados</a>
            </li>
            <li>
              <a href="#como-funciona" className="hover:text-accent-400 transition-colors">Como funciona</a>
            </li>
            <li>
              <a href="#faq" className="hover:text-accent-400 transition-colors">Dúvidas</a>
            </li>
          </ul>
        </div>

        <div>
          <div className="font-heading text-background-50 font-semibold mb-3">Contato</div>
          <a
            href="https://wa.me/5547991891311"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-full bg-accent-500 px-4 py-2.5 text-sm text-primary-950 hover:bg-background-50 transition-colors whitespace-nowrap"
          >
            <i className="ri-whatsapp-line"></i>
            WhatsApp
          </a>
        </div>
      </div>

      <div className="border-t border-background-50/10">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-5 text-xs text-background-50/50 flex flex-wrap justify-between gap-2">
          <div>© 2026 AVcertifica. Todos os direitos reservados.</div>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-1 justify-end">
            <span>Certificados emitidos por meio da Soluti, Autoridade Certificadora de 1º nível na ICP-Brasil.</span>
            <span>Certificados com validade jurídica dentro da ICP-Brasil.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}